import {Link} from 'react-router-dom';
import {styled, useTheme} from '@mui/material/styles';
import Typography from '@mui/material/Typography';

import {APP_VERSION} from 'core/constants/globalVariables';
import {ENNABL_PRIVACY_POLICY} from 'core/constants/paths';
import {useFeatureFlag} from 'core/hooks/authHooks';
import {FeatureFlags} from 'core/constants/featureFlags';

import PoweredByIcon from 'components/icons/poweredBy.svg';

type ShrinkProp = {
  shrink?: boolean;
};

const SRoot = styled('footer')<ShrinkProp>(({theme, shrink}) => ({
  padding: theme.spacing(shrink ? 4 : 8),
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  // for compatibility w/ upper logic
  flexShrink: 0,
}));

const SWrapper = styled('div')(({theme}) => ({
  height: 20,
  display: 'flex',
  alignItems: 'baseline',
  gap: theme.spacing(4),
}));

const SPrivacyPolicyLink = styled(Link)(({theme}) => ({
  ...theme.typography.body3,
  color: theme.palette.text.secondary,
  textDecoration: 'none',
  '&:hover': {
    textDecoration: 'underline',
  },
}));

export default function AppVersionFooter({shrink}: ShrinkProp) {
  const theme = useTheme();
  const withPrivacyPolicy = useFeatureFlag(FeatureFlags.PrivacyPolicyPage);

  return (
    <SRoot shrink={shrink}>
      <SWrapper>
        <PoweredByIcon color={theme.palette.logo.primary} />
        <Typography variant='body3' color='text.secondary'>
          VERSION {APP_VERSION}
        </Typography>
        {withPrivacyPolicy && <SPrivacyPolicyLink to={ENNABL_PRIVACY_POLICY}>Privacy Policy</SPrivacyPolicyLink>}
      </SWrapper>
    </SRoot>
  );
}
